import { Breadcrumb, Card, Col, Icon, Popconfirm, Row, Tabs, Tooltip } from 'antd'
import PaymentButton from '../../../../components/Sales/Enquiries/AddEnquiry/PaymentButton'
import { EnquiriesApi } from '../../../../api/Sales/Enquiries'
import Documents from '../../../../components/Common/Documents/DocumentsCont'
import History from '../../../../components/Common/History'
import TimelineFeedCont from '../../../../components/Common/TimelineFeed/TimelineFeedCont'
import RFQList from '../../../../components/Purchasing/RFQ/List'
import VendorQuotesList from '../../../../components/Purchasing/VendorQuotes/List'
import EnquiriesForm from '../../../../components/Sales/Enquiries/EnquiriesForm'
import Files from '../../../../components/Sales/Enquiries/Files'
import Folders from '../../../../components/Sales/Enquiries/Folders'
import EnquiriesLinesCont from '../../../../components/Sales/Enquiries/Lines/EnquiriesLinesCont'
import OrdersList from '../../../../components/Sales/Orders/OrdersList'
import QuotesList from '../../../../components/Sales/Quotes/List'
import style from '../../../../components/Sales/style.css'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../../elements/CustomSpin'
import FormSectionTitle from '../../../../elements/FormSectionTitle'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import Status from '../../../../elements/Status'
import { get, isEmpty } from 'lodash'
import { idMaker, strVal } from '../../../../modules/Utils'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import IconText from '../../../../elements/IconText'
import Authentication from '../../../../modules/Authentication'
import { streamUrl } from '../../../../variables'
import EmailCont from '../../../Common/Email/EmailCont'
import TaskSystemList from '../../../Operations/TaskSystem/List'
import DeliveryOrderList from '../../../Purchasing/DeliveryOrder/DeliveryOrderList'
import { AddEnquiryContext } from '../../Enquiries/AddEnquiry/AddEnquiriesCont'
import EmailListCont from '../../../Main/Emails/EmailCont'

const { TabPane } = Tabs
const ids = idMaker()
const auth = new Authentication()

function AddEnquiry(props) {
  const {
    fetchingActions,
    type,
    submitting,
    updating,
    fetching,
    submit,
    fetch,
    update,
    handleActions,
    formRef,
    enquiry,
    showEmail,
    showEmailDEC,
    visibleEmail,
    onCancelEmail,
    emailTemplate,
    emailDetails,
    emailFiles,
    emailLines,
    actions,
    remove,
    removing,
    docStatus,
  } = React.useContext(AddEnquiryContext)

  const { list: listRFQ, fetching: fetchingRFQ, fetch: fetchRFQ } = useFetchList(
    () => EnquiriesApi.rfq(enquiry._key),
    [enquiry._key],
    isEmpty(enquiry._key)
  )
  const { list: listQuotes, fetching: fetchingQuotes, fetch: fetchQuotes } = useFetchList(
    () => EnquiriesApi.quotes(enquiry._key),
    [enquiry._key],
    isEmpty(enquiry._key)
  )

  const { list: listVendorQuotes, fetching: fetchingVendorQuotes, fetch: fetchVendorQuotes } = useFetchList(
    () => EnquiriesApi.vendorQuotes(enquiry._key),
    [enquiry._key],
    isEmpty(enquiry._key)
  )

  const { list: listSalesOrder, fetching: fetchingSalesOrder, fetch: fetchSalesOrder } = useFetchList(
    () => EnquiriesApi.salesOrder(enquiry._key),
    [enquiry._key],
    isEmpty(enquiry._key)
  )

  const { list: listTasks, fetching: fetchingTasks, fetch: fetchTasks } = useFetchList(
    () => EnquiriesApi.tasks(enquiry._key),
    [enquiry._key],
    isEmpty(enquiry._key)
  )

  const { list: listDelivery, fetching: fetchingDelivery, fetch: fetchDelivery } = useFetchList(
    () => EnquiriesApi.deliveryOrder(enquiry._key),
    [enquiry._key],
    isEmpty(enquiry._key)
  )

  const Operations = ({ enquiry, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure you want to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      )) /**/ /*enquiry.status !== 'Confirmed' &&
    ops.push(
      <a
        target={'_blank'}
        href={`${streamUrl}pdf/${
          enquiry._id
        }?access_token=${auth.getAccessToken()}`}>
        <IconText text={'PDF preview'} type={'file-pdf'} />
      </a>,
    )*/
    /*if (ops.length > 0 && enquiry.status === 'Confirmed') {
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to Duplicate?`}
            onConfirm={() => handleActions('duplicate')}
            okText="Yes"
            cancelText="No">
            <a>Duplicate</a>
          </Popconfirm>
        </span>,
      )
    }*/
    if (enquiry.status === 'New Lead' || enquiry.status === 'Opportunity') {
      ops.push(
        <a onClick={showEmailDEC}>
          <IconText text={'Decline to Quote'} type={'mail'} />
        </a>
      )
    }
    enquiry.status === 'New Lead' &&
      ops.push(
        <a onClick={showEmail}>
          <IconText text={'Acknowledge Enquiry'} type={'mail'} />
        </a>
      )
    ops.push(
      <a
        target={'_blank'}
        href={`${streamUrl}pdf/enquiries/${enquiry._key}/summary?access_token=${auth.getAccessToken()}`}>
        <IconText text={'View Summary'} type={'file-pdf'} />
      </a>
      // <RefreshButton onClick={fetch} />,
    )

    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }

  const SubmitButton = () => (
    <FooterButtons
      style={{ marginBottom: 10 }}
      remove={remove}
      removing={removing}
      submit={submit}
      update={update}
      submitting={submitting || updating}
      title={'Department'}
      isNew={isNew}
      isEdit={!isNew}
      isRemovable={false}
    />
  )

  const isNew = type === 'new'
  return (
    <CustomSpin spinning={fetching || fetchingActions}>
      <Card style={{ maxWidth: '96%' }}>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sales</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/clients/enquiries`}>Enquiries</Breadcrumb.Item>
            <Breadcrumb.Item>{type === 'new' ? 'New Enquiry' : enquiry.code}</Breadcrumb.Item>
          </Breadcrumb>
          {type === 'new' && <h2 className={style.title}>New Enquiry</h2>}
          {type === 'edit' && (
            <Fragment>
              <Col span={17}>
                <h3 className={style.title}>
                  <h2 className={'icon-text-header'}>
                    <Icon
                      type="barcode"
                      style={{
                        marginRight: '5px',
                        color: '#08c',
                      }}
                    />
                    <Tooltip title="Enquiry (MAC) Code">{strVal(enquiry, 'code')}</Tooltip>
                  </h2>
                  <Status value={strVal(enquiry, 'status')} />
                  <Operations style={{ marginTop: '10px' }} enquiry={enquiry} status={strVal(enquiry, 'status')} />

                </h3>
              </Col>
              <RefreshButton onClick={fetch} />
            </Fragment>
          )}

          {type === 'new' && (
            <>
              <p className={style.paragraph}>Create a new enquiry</p>
            </>
          )}
        </Row>
      </Card>
      <EmailCont
        key={ids.next().value}
        visible={visibleEmail}
        onCancel={onCancelEmail}
        template={emailTemplate}
        email={emailDetails}
        files={emailFiles}
        lines={emailLines}
        status={docStatus}
      />
      <Card className={style.contentCard} style={{ maxWidth: '96%' }}>
        <Tabs defaultActiveKey={get(props, 'location.hash') || '#details'} onChange={(key) => props.history.push(key)}>
          <TabPane tab="Details" key="#details">
            <SubmitButton />
            <Row>
              <EnquiriesForm ref={formRef} {...props} />
              <FormSectionTitle title={'ENQUIRY LINES'} />
              <EnquiriesLinesCont key={enquiry._key} enquiry={enquiry} />
            </Row>
            <SubmitButton />
          </TabPane>
          <TabPane disabled={type !== 'edit'} tab={'Tasks & Notes'} key="#tasks-notes">
            <Tabs defaultActiveKey="1">
              <TabPane tab="Notes" key="1">
                <TimelineFeedCont {...{ owner: enquiry._id, hideNotification: true }} />
              </TabPane>
              <TabPane tab="Tasks" key="2">
                <TaskSystemList
                  fetching={fetchingTasks}
                  fetch={fetchTasks}
                  list={listTasks}
                  hideCompany={true}
                  enquiry={enquiry}
                />
              </TabPane>
            </Tabs>
          </TabPane>
          <TabPane disabled={type !== 'edit'} tab={'RFQ'} key="#rfq">
            <RFQList
              enquiryID={enquiry._id}
              fetching={fetchingRFQ}
              fetch={fetchRFQ}
              list={listRFQ}
              hideCompany={true}
            />
          </TabPane>
          <TabPane disabled={type !== 'edit'} tab={'Vendor Quotes'} key="#vendor-quotes">
            <VendorQuotesList
              fetching={fetchingVendorQuotes}
              fetch={fetchVendorQuotes}
              list={listVendorQuotes}
              hideCompany={true}
            />
          </TabPane>
          <TabPane disabled={type !== 'edit'} tab={'Customer Quotes'} key="#quotes">
            <QuotesList
              enquiryID={enquiry._id}
              fetching={fetchingQuotes}
              fetch={fetchQuotes}
              list={listQuotes}
              hideCompany={true}
            />
          </TabPane>

          <TabPane disabled={type !== 'edit'} tab={'Sales Orders'} key="#sales">
            <OrdersList
              enquiryID={enquiry._id}
              fetching={fetchingSalesOrder}
              fetch={fetchSalesOrder}
              list={listSalesOrder}
              hideCompany={true}
            />
          </TabPane>

          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="file-text" />
                Delivery Orders
              </span>
            }
            key="#delivery">
            <DeliveryOrderList
              {...{
                list: listDelivery,
                fetching: fetchingDelivery,
                fetch: fetchDelivery,
                hideCompany: true,
                hideCreate: true,
              }}
            />
          </TabPane>
          <TabPane tab="Email" key="#email">
            <EmailListCont owner={enquiry._id} />
          </TabPane>
          <TabPane disabled={isNew} tab="Documents" key="#files">
            <Documents
              key={enquiry._rev}
              editable={true}
              footer={false}
              category={false}
              email={true}
              owner={enquiry}
              linkTo={true}
              linkToType={'RFQ'}
            />
          </TabPane>
          <TabPane disabled={type !== 'edit'} tab={'History'} key="#history">
            <History loading={fetching} owner={enquiry} />
          </TabPane>
          <TabPane disabled={type !== 'edit'} tab={'Transmittal'} key="#transmittal">
            <Tabs defaultActiveKey="folders" tabPosition="left">
              <TabPane tab="Folders" key="folders">
                <Folders enquiry={enquiry} />
              </TabPane>
              <TabPane tab="Files" key="files">
                <Files enquiry={enquiry} />
              </TabPane>
            </Tabs>
          </TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

AddEnquiry.propTypes = {}
AddEnquiry.defaultProps = {}

export default withRouter(AddEnquiry)
